/// <amd-module name="Build/Common/Library/String" />
/**
 * ASCII to Unicode (decode Base64 to original data)
 * @param {string} s The string that should be encoded.
 * @return {string} The string in base64 encoding.
 */
export function atou(s: string): string {
    return decodeURIComponent(escape(window.atob(s)));
}

/**
 * Unicode to ASCII (encode data to Base64)
 * @param {string} s The string should be decoded.
 * @return {string} The decoded string in Unicode.
 */
export function utoa(s: string): string {
    return window.btoa(unescape(encodeURIComponent(s)));
}